import { render, staticRenderFns } from "./labelIconPosition-editor.vue?vue&type=template&id=1ca50aa1&scoped=true"
import script from "./labelIconPosition-editor.vue?vue&type=script&lang=js"
export * from "./labelIconPosition-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca50aa1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ca50aa1')) {
      api.createRecord('1ca50aa1', component.options)
    } else {
      api.reload('1ca50aa1', component.options)
    }
    module.hot.accept("./labelIconPosition-editor.vue?vue&type=template&id=1ca50aa1&scoped=true", function () {
      api.rerender('1ca50aa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/labelIconPosition-editor.vue"
export default component.exports